import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import ENUMS from '../../../utils/ENUMS.js';
import { BASE_URL } from '../../../config.json';

const RenewGolfCourses = (props) => {
  const userTemplate = { course_name: '', number_of_holes: '' };
  const [users, setUsers] = useState([userTemplate]);
  const [holes, setHoles] = useState([]);

  // Populate courses from local storage if available
  const populateCourseFromLocalStorage = () => {
    const savedCourses = localStorage.getItem('Renew-Create-GolfCourse');
    if (savedCourses) {
      setUsers(JSON.parse(savedCourses));
    }
  };

  // Fetch dropdown options for holes
  const fetchHolesDropdown = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/club/get_course_holes/`);
      const dropdownList = res.data.data || [];
      setHoles(dropdownList);
    } catch (error) {
      console.error('Error fetching holes:', error);
    }
  };

  // Add a new user to the list
  const addUser = () => setUsers([...users, userTemplate]);

  // Remove a user from the list
  const removeUser = (index) => {
    const updatedUsers = [...users];
    updatedUsers.splice(index, 1);
    setUsers(updatedUsers);
  };

  // Handle input changes
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedUsers = users.map((user, i) =>
      i === index ? { ...user, [name]: value } : user
    );
    setUsers(updatedUsers);
  };

  // Save courses to local storage
  const storeGolfCourseInLocalStorage = () => {
    localStorage.setItem('Renew-Create-GolfCourse', JSON.stringify(users));
  };

  // Handle form submission
  const handleSubmit = () => {
    const isValid = users.every((user) => user.course_name && user.number_of_holes);

    if (isValid) {
      props.SetUsers({ users });
      props.SetScreenPostion(3);
      storeGolfCourseInLocalStorage();
    } else {
      console.error('Please fill out all fields');
    }
  };

  useEffect(() => {
    populateCourseFromLocalStorage();
    fetchHolesDropdown();
  }, []);

  return (
    <div className="gCourses">
      <h1 className="login-title text-jost-sb-50-wt">Sign up your club today</h1>
      <div className="gCourses__wrap">
        <div className="gCourses__bar">
          <ul className="gCourses__bar__row">
            <li className="text-jost-sb-22 completed">CLUB Details</li>
            <li className="text-jost-sb-22 active">Golf Courses</li>
            <li className="text-jost-sb-22">Payment DETAILS</li>
            <li className="text-jost-sb-22">Confirmation</li>
          </ul>
        </div>
        <h2 className="text-jost-sb-22">How many Golf Courses do you have?</h2>
        <div className="gCourses__box">
          {users.map((user, index) => (
            <div key={index} className="acccore__box__sec2">
              <div className="custom-select-wrapper">
                <input
                  className="acc__input-lg"
                  type="text"
                  placeholder="Course Name"
                  name="course_name"
                  onChange={(e) => handleChange(e, index)}
                  value={user.course_name}
                />
                {!user.course_name && <span style={{ color: 'red' }}>* Required</span>}
              </div>
              <div className="custom-select-wrapper">
                <select
                  name="number_of_holes"
                  className="acc__input-lg"
                  onChange={(e) => handleChange(e, index)}
                  value={user.number_of_holes}
                >
                  <option value="" disabled>
                    SELECT NO OF HOLES
                  </option>
                  {holes.map((hole, i) => (
                    <option key={i} value={hole.value}>
                      {hole.label}
                    </option>
                  ))}
                </select>
                {!user.number_of_holes && <span style={{ color: 'red' }}>* Required</span>}
              </div>
              <div>
                <button onClick={addUser}>
                  <img src={require('../../../assets/images/btn/plus_btn.svg').default} alt="" />
                </button>
                {users.length > 1 && (
                  <button
                    style={{ paddingRight: '140px', backgroundColor: 'white' }}
                    onClick={() => removeUser(index)}
                  >
                    <img
                      src={require('../../../assets/images/del/delete.svg').default}
                      alt=""
                    />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="gCourses-links">
          <button className="res-btn-ternary" onClick={() => props.SetScreenPostion(1)}>
            Back
          </button>
          <button className="res-btn-primary" onClick={handleSubmit}>
            Save & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenewGolfCourses;
